
export default {
  name: 'CommonButton',
  emmits: ['click'],
  props: {
    useSize: {
      type: String,
      default: 'lg'
    },
    useColor: {
      type: String,
      default: ''
    },
    useTheme: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup (props, ctx) {
    const click = () => ctx.emit(
      'click'
    )
    return { click }
  },
  data () {
    return {
      sizeType: {
        xxs: 'xxs',
        xs: 'xs',
        sm: 'sm',
        md: 'md',
        lg: 'lg',
        xl: 'xl'
      },
      colorType: {
        primary: 'btn-p',
        primary2: 'btn-p2',
        secondary: 'btn-s',
        third: 'btn-t',
        dark: 'btn-d',
        extra: 'btn-e',
        excel: 'btn-ex',
        inactive: 'in-active',
        emphasis: 'emphasis'
      },
      btnTheme: {
        radiusArrow: 'arrow-radius',
        arrowRight: 'arrow-right'
      }
    }
  }
}
